import * as Adaptive from "adaptivecards";
import { CustomPropertyDataType_LABELS } from "../../../custom-properties/utils/constants";

const displayLabelProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "displayLabel", true);
const requireFieldProperty = new Adaptive.BoolProperty(Adaptive.Versions.v1_0, "requireField");
const isCustomPropertyProp = new Adaptive.BoolProperty(Adaptive.Versions.v1_0, "isCustomProperty", false);
const dataTypeProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "dataType", true);

export class CustomPropertyBase extends Adaptive.TextInput {
    static readonly displayLabelProperty = displayLabelProperty;
    static readonly isCustomPropertyProp = isCustomPropertyProp;
    static readonly requireFieldProperty = requireFieldProperty;
    static readonly dataTypeProperty = dataTypeProperty;

    //#region Schema

    @Adaptive.property(displayLabelProperty)
    get displayLabel(): string | undefined {
        return this.getValue(CustomPropertyBase.displayLabelProperty);
    }

    set displayLabel(value: string | undefined) {
        this.setValue(CustomPropertyBase.displayLabelProperty, value);
        this.updateLayout();
    }

    @Adaptive.property(requireFieldProperty)
    get requireField(): boolean | undefined {
        return this.getValue(CustomPropertyBase.requireFieldProperty);
    }

    set requireField(value: boolean | undefined) {
        this.setValue(CustomPropertyBase.requireFieldProperty, value);
        this.updateLayout();
    }

    @Adaptive.property(isCustomPropertyProp)
    get isCustomProperty(): boolean | undefined {
        return this.getValue(CustomPropertyBase.isCustomPropertyProp);
    }

    set isCustomProperty(value: boolean | undefined) {
        this.setValue(CustomPropertyBase.isCustomPropertyProp, value);
        this.updateLayout();
    }

    @Adaptive.property(dataTypeProperty)
    get dataType(): string | undefined {
        return this.getValue(CustomPropertyBase.dataTypeProperty);
    }

    set dataType(value: string | undefined) {
        this.setValue(CustomPropertyBase.dataTypeProperty, value);
        this.updateLayout();
    }

    //#endregion

    internalRender(): HTMLElement | undefined {

        if(!(this?.isCustomProperty ?? false))
            this.isCustomProperty = true;

        let cardElement: Adaptive.CardElement;
        let labelProp = "label";
        switch(CustomPropertyDataType_LABELS[this.dataType]){
            case CustomPropertyDataType_LABELS.INT:
                cardElement = new Adaptive.NumberInput();
                break;
            case CustomPropertyDataType_LABELS.BOOL:
                cardElement = new Adaptive.ToggleInput();
                labelProp = "title";
                break;
            case CustomPropertyDataType_LABELS.DATE:
                cardElement = new Adaptive.DateInput();
                break;
            case CustomPropertyDataType_LABELS.TIME:
                cardElement = new Adaptive.TimeInput();
                break;
            default:
                cardElement = new Adaptive.TextInput();
                break;
        }
        cardElement.setParent(this);
        cardElement[labelProp] = this.displayLabel;
        cardElement["isRequired"] = this.requireField;
        cardElement["errorMessage"] = this.errorMessage;

        if(this.defaultValue)
            cardElement["defaultValue"] = this.defaultValue;
        const renderedElement =  cardElement.render();
        this.inputControlContainerElement.style.display = "block";
        this.inputControlContainerElement.classList?.add("tikit-customProperty");
        return renderedElement;
    }

    updateLayout(processChildren: boolean = true) {
        super.updateLayout(processChildren);
    }
}